export default "__VITE_ASSET__$d$DBA4D__"